import { roleHasPermission, type Permission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useSitePermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "sites:read"),
    canWrite: roleHasPermission(role, "sites:write"),
    canConfigureGeofence: roleHasPermission(role, "geofence:configure"),
    canViewGeofence: roleHasPermission(role, "geofence:read"),
    isReadOnly: roleHasPermission(role, "sites:read") && !roleHasPermission(role, "sites:write"),
    role,
  };
}

export function hasPermission(role: string, permission: Permission): boolean {
  return roleHasPermission(role as Parameters<typeof roleHasPermission>[0], permission);
}
